let ignore_onbeforeunload = false;
gsap.registerPlugin(ScrollTrigger, Flip, SplitText);
// height fix
if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

if($(window).width() < 960){
    var vhh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vhh+'px');

    window.addEventListener('resize', function() {
        var vhh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vhh+'px');
    });
}

$('input, textarea').each(function () {
    var $this = $(this);

    if (this.value) {
        $this.removeClass('placeholder-shown');
        $this.next().removeClass('placeholder-shown');
    } else {
        $this.addClass('placeholder-shown');
        $this.next().addClass('placeholder-shown');
    }
});

$('input, textarea').on('change keyup', function () {
    var $this = $(this);

    if (this.value) {
        $this.removeClass('placeholder-shown');
        $this.next().removeClass('placeholder-shown');
    } else {
        $this.addClass('placeholder-shown');
        $this.next().addClass('placeholder-shown');
    }
});

$('form.contact-form').submit(function () {
    let $this = $(this);
    let $messages = $this.find('.form-messages').removeClass('error').removeClass('success');
    $('form.contact-form').find('button[type="submit"]').attr("disabled", true);

    $.post(
        $this.attr('action'),
        $this.serialize())
        .done(function (data) {
            $('form.contact-form').find('button[type="submit"]').attr("disabled", false);
            if (data.status == 0) {
                $messages.addClass('error');
                $('[class^="form-item"]').removeClass('error');
                $('[class^="form-item-text"]').removeClass('show-error');

                $.each(data.errors, function (index, value) {
                    $('.form-item-' + index).addClass('error');
                    $('.form-item-text-' + index).addClass('show-error').text(value);
                });
            } else {

                $('[class^="form-item"]').removeClass('error');
                $('[class^="form-item-text"]').removeClass('show-error');
                $('form.contact-form input:not([type="hidden"]):not([type="checkbox"]), form.contact-form textarea').val('');
                $('form.contact-form input[type="checkbox"]').prop("checked", false);
                $('.floating-label').addClass('placeholder-shown');
                $this.find('>*').hide();
                $messages.addClass('success-message').show();
                if ($this.hasClass('subscribe-form')) $('.subscribe .title').hide();
                $('h1.popup-title').text(data.message);
            
                setTimeout(() => {
                    if(window.smooth != undefined) window.smooth.refresh();
                    console.log("!");
                },10);

                if(typeof fbq === "function") fbq('track', 'CompleteRegistration', {content_name: "Issiusta uzklausa"});
                if(typeof gtag === "function") gtag('event','issiuntimas', {'event_category': 'forma','event_label': 'Registracijos forma',});
                if(typeof gtag === "function") gtag('event', 'conversion', {'send_to': 'AW-10780676696/HTgLCOHSmokYENik0JQo'});
              
            }
        });

    return false;
});

$('.js-accept-gdpr').click(function(e){
    $('.gdpr').fadeOut();
    Cookies.set('gdpr', 'yes');
    e.preventDefault();
});

$('.js-toggle-menu').click(function(e){
    $('.site-menu').toggleClass('active');
    $('.offer-btn').toggleClass('active');
    e.preventDefault();
});

function siteHeaderScroll(){
    const po = window.location.pathname.includes('rinktis') || window.location.pathname.includes('select');
    //console.log($( document ).width() <= 767, po, window.location.pathname);
    let dark = $('.site-header').attr("data-dark");
    //console.log(dark);
    if ($(window).scrollTop() > 20) {
        $('.site-header').addClass('scroll');
        if (dark) $('.site-header').removeClass('site-header-dark');
        if($( document ).width() <= 767 && po) $('.site-header').removeClass('site-header-dark');
    } else {
        $('.site-header').removeClass('scroll');
        if (dark) $('.site-header').addClass('site-header-dark');
        // rinktis at 767 we get white line at the top
        if($( document ).width() <= 767 && po) $('.site-header').addClass('site-header-dark'); 
    }
}


let mul = 0;
$(document).ready(function () {
    siteHeaderScroll();

    $(window).scroll(function () {
        siteHeaderScroll();
    });

    if($('.plan-slider').length){
        let slider = tns({
            container: '.plan-slider',
            mode: 'gallery',
            slideBy: 'page',
            autoplay: false,
            nav: false,
            mouseDrag: false,
            controls: false,
            touch: false,
            autoplayButtonOutput: false,
            animateDelay: 3400,
            autoplayTimeout: 5000,
            loop: true,
            speed: 2000,
            items: 1,
            onInit: function(){
                $('.plan').show().css({'opacity': '1'})
            }
        });

        $('.plan-slider-nav button').on('click', function() {
            let $this = $(this);
            let controls = $this.data('controls');
            slider.goTo(controls);

            const info = slider.getInfo();
            const item = info.slideItems[info.index];
            const floor = $(item).data('floor');
            let plan = $(item).data('plan');

            if(plan === '2d') {
                plan = 0;
            } else {
                plan = 1;
            }

            $('.slider-btn-dual').removeClass('active');
            $('.slider-btn').removeClass('active');

            
            $(`.slider-btn-dual[data-to="${(floor-1)}"]`).addClass('active');
            $(`.slider-btn[data-to="${plan}"]`).addClass('active');

            console.log(plan,item.dataset.plan,'test');
            if(item.dataset.plan == 'gallery') {
                    $('.slider-btn-dual').removeClass('active');
                    $('.slider-btn').removeClass('active');
                    $('.slider-btn[data-to="5"]').addClass('active');
            }

            if(item.dataset.plan == '4d') {
                $('.slider-btn-dual').removeClass('active');
                $('.slider-btn').removeClass('active');
                $('.slider-btn[data-to="4"]').addClass('active');
            }
   
        })

        $('.slider-btn').on('click', function() {
            $('.slider-btn').removeClass('active');
            $('.slider-btn-dual').removeClass('active');
            let $this = $(this);
            let numb = $this.data('to');
            slider.goTo((numb +  mul));
            $(`.slider-btn[data-to="${numb}"]`).addClass('active');
        });

        $('.slider-btn-dual').on('click', function() {
             $('.slider-btn[data-to="5"]').removeClass('active');
            let $this = $(this);
            if($this.hasClass('active')) return;

            let to = $this.data('to');
            $('.slider-btn-dual').removeClass('active');

            if (to === 0) {
                mul = 0;
            } else {
                mul = 2; 
            }

            const $active = $('.slider-btn.active');
            if($active.length == 0) {
                    $('.slider-btn[data-to="0"]').addClass('active');
            }
   
            $(`.slider-btn-dual[data-to="${to}"]`).addClass('active');
            let m = $('.slider-btn.active').data('to') + mul;
            console.log(m,'m',$('.slider-btn.active'))
            slider.goTo(m);
        });

        // change to 3d
        const info = slider.getInfo();
        if(info.slideCount >= 2) {
            if($('a[data-plan="3d"]').length != 0) {
                $(`.slider-btn[data-to="0"]`).removeClass('active');
                $(`.slider-btn[data-to="1"]`).addClass('active');
                slider.goTo(1);
            }
        }
    }
});

//buttons to scroll too contacts
$(document).on('click','.scroll-contacts-js',function(e) {
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".site-footer").offset().top
    }, 2000);
    if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Paspaude Kontaktai"});
    if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'kontaktai',});
    if(typeof gtag === "function") gtag('event', 'conversion', {'send_to': 'AW-10780676696/oT4yCOrSmokYENik0JQo','event_callback': () => {}});

});

// buttons to scroll to0 filter
$(document).on('click','.scroll-filter-js',function(e) {
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".aparts-filter-main").offset().top - 80
    }, 2000);
});


$(document).on('click','.btn-to-contact-js',function() {
    Cookies.set('scroll-filter', 1);
});


// press hearts
$(document).on('click','.favorites-js, .favorites-apartments', function(){
    let favoriteData = JSON.parse(Cookies.get('favorites') || '[]');

    let $this = $(this);
    let id = $this.data('id');
    let title = $this.data('title');
    
    if(!$this.hasClass("active")){
        let floater = $("header>.right-side>.fv-flow>svg");
        let startSVG = $this.find("svg");
        let endSVG = $("header>.right-side>.favorites-header>svg");

        let vars1 = Flip.fit(floater.get(0), startSVG.get(0), {scale: true, getVars: true});
        let vars2 = Flip.fit(floater.get(0), endSVG.get(0), {scale: true, getVars: true});
        vars1.opacity = 1;
        vars2.opacity = 0;
        vars2.duration = 2;
        vars2.ease = "expo.out";
        vars2.overwrite = true;

        gsap.fromTo(floater, vars1, vars2);
    }

    let find = favoriteData.findIndex((element) => element === id);
    if(find != -1) {
        favoriteData.splice(find, 1);
    } else {
        favoriteData.push(id);
    }

    if ($('.aparts-table-favorite').length != 0) {
        $this.parent().parent().hide();
        favorite.updateContactForm(title);
    }

    Cookies.set('favorites', JSON.stringify(favoriteData), 7);
    favorite.updateHeader();

    $this.toggleClass('active');
});

//contact form remove pill
$(document).on('click','.item .close',function(e) {
    let id = $(this).parent().data('id');
    favorite.updateContactForm(id);
});

//close modal and submit
$(document).on('click','.close-popup',function(e) {
    e.preventDefault();
    Cookies.set('algirdopopup', 1);
    $(".offers-popup").removeClass('show');
    $('body').removeClass('overflow-hidden');
});


// refresh filter 
$(document).on('click','.js-refresh-filter',function(e) {
    //atributes
    $('.benefits-filter .items').text('');
    $('.benefits-filter .js-title').removeClass('active');

    $('.benefits-dropdown input').prop('checked', false);
    $('.js-benefits-mobile').removeClass('active');
    //floors
    $('#floor1, #floor2, #floor3, #floor4, #floor5').prop('checked', false);
    $('#room1, #room2, #room3, #room4, #room5').prop('checked', false);
    $('#filter-A, #filter-P, #filter-S').prop('checked', false);
    if($('#price-slider').length != 0) {
        $('#price-slider').data("ionRangeSlider").reset();
        $('.slider').data("ionRangeSlider").update({
            min: $('#price-slider').data('min'),
            max: $('#price-slider').data('max'),
            from: $('#price-slider').data('min'),
            to: $('#price-slider').data('max'),
        });
        
    }
    

    //other
    $('#filter-1').prop('checked', false);
    $('#filter-2').prop('checked', false);

    filter.submit();
});

if($('.house-locked').length) {
    $('.house-locked').on('mouseenter', function() {
        $(this).parent().parent().find('.tooltip-none').addClass('visible');
    }).on('mouseleave', function() {
        $('.tooltip-none').removeClass('visible');
    });
}

$('.menu-item-js').on('click', function(e) {
    e.preventDefault();
    $('.site-menu').removeClass('active');
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".site-footer").offset().top 
    }, 2000);

    if(typeof fbq === "function") fbq('track', 'Contact', {content_name: "Paspaude Kontaktai"});
    if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas','event_label': 'kontaktai',});

    if(typeof gtag === "function") gtag('event', 'conversion', {'send_to': 'AW-10780676696/oT4yCOrSmokYENik0JQo','event_callback': () => {}});
});

if(window.location.hash){
    if(window.location.hash == '#kontaktai'){
        setTimeout(() => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".site-footer").offset().top 
            }, 2000);
        },50)
    }
};


const popup = {
    init: () => {
        const cookie = Cookies.get('algirdopopup');
        if(cookie == null) {
            if(popupShow === '0') return;
            if(popupLeave === 1) {
                $('document').on('mouseleave', function() {
                    const cookie = Cookies.get('algirdopopup');
                    if(cookie == null) {
                        $(".offers-popup").addClass('show');
                        Cookies.set('algirdopopup', 1);
                        //$('body').addClass('overflow-hidden');
                    }
                });
                return;
            }

            setTimeout(() => {
                $(".offers-popup").addClass('show');
                Cookies.set('algirdopopup', 1);
                //$('body').addClass('overflow-hidden');
            }, popupTimer * 1000);
        }
    }
}


// code toolip floors

$('.floor-nav a').on('click', function(e) {
    e.preventDefault();
    let $this = $(this);
    let floorOld = $('.floor-nav a.active').text();
    $('.floor-nav a').removeClass('active');
    $this.addClass('active');
    let floor = $this.text();
    
    let url = window.location.href;
    url = url.split(`/${floorOld  === 'P' ? '0' : floorOld}`);
    history.pushState({}, null,url[0] + `/${floor === 'P' ? '0' : floor}` + url[1]);

    if(floor === 'P') {
        $('.statuses div.visible').removeClass('visible');
        $(`.statuses div[data-floor="Parking"]`).addClass('visible');

        $('.floor-svg').removeClass('floor-svg-visible');
        $(`.floor-svg[data-floor="Parking"][data-house="any"]`).addClass('floor-svg-visible');
        return;
    }

    let house = $('.floor-svg-visible').data('house');
    if(house == 'any' || house == undefined) {
        if(url[0].includes('Algirdo')) house = 'Algirdo';
        if(url[0].includes('Skvero')) house = 'Skvero';
        if(url[0].includes('Promenada')) house = 'Promenada';
    }

    console.log(url, house,floor);

    $('.statuses div.visible').removeClass('visible');
    $(`.statuses div[data-house="${house}"][data-floor="${floor}"]`).addClass('visible');
    
    $('.floor-svg').removeClass('floor-svg-visible');
    $(`.floor-svg[data-floor="${floor}"][data-house="${house}"]`).addClass('floor-svg-visible');
});

$('.houses-2d-js a').on('click', function(e) {
    e.preventDefault();

    let $this = $(this);
    let houseOld = $('.houses-2d-js a.active').data('house');
    let house = $this.data('house');
    let url = window.location.href.split("?")[0];
    let query = window.location.href.split("?")[1];
    url = url.split(`/${houseOld}/`);

    if(this.dataset.special != undefined) {
        $('.floor-svg').removeClass('floor-svg-visible');
        $(`.floor-svg[data-floor="1"][data-house="Algirdo"]`).addClass('floor-svg-visible');

        $('.statuses div.visible').removeClass('visible');
        $(`.statuses div[data-house="Algirdo"][data-floor="1"]`).addClass('visible');

        $('.floor-nav a').removeClass('active');
        $('.floor-nav li[data-floor="1"] a').addClass('active');

        $('.houses-2d-js a').removeClass('active');
        $('.floor-btn[data-select="1"]').addClass('active');

        history.pushState({}, null,url[0] + `/Algirdo/1${query === undefined ? '' : "?" + query}`);
        return;
    }

    if(house === 'Promenada')  {
        if(url[1][0] == 5) url[1] = 4 + url[1].substring(1);
        $('.floor-nav a').removeClass('active');
        $(`.floor-nav li[data-floor="${url[1][0]}"] a`).addClass('active');
        $('.floor-nav li[data-floor="5"]').hide();
    } else {
        $('.floor-nav li[data-floor="5"]').show();
    }

    $('.statuses div.visible').removeClass('visible');
    $(`.statuses div[data-house="${house}"][data-floor="${url[1][0]}"]`).addClass('visible');

    $('.houses-2d-js a').removeClass('active');
    $this.addClass('active');

  
    history.pushState({}, null,url[0] + `/${house}/${url[1]}${query === undefined ? '' : "?" + query}`);

    $('.floor-svg').removeClass('floor-svg-visible');
    if(url[1][0] == '0') {
        $(`.floor-svg[data-floor="Parking"][data-house="any"]`).addClass('floor-svg-visible');
        return;
    }

    $(`.floor-svg[data-floor="${url[1][0]}"][data-house="${house}"]`).addClass('floor-svg-visible');
});





$(document).ready(function() {
    menu.init();
    apartments.init();
    floorsObj.init('.floor-svg-visible','.floor-plans-inside', '#floor-tooltip');
    popup.init();

    window.onbeforeunload = function () {
        if(ignore_onbeforeunload == true) {
            ignore_onbeforeunload = false;
            return;
        }

        document.querySelector('.site-wrapper-dark').style.cssText = 'opacity: 0';
        window.scrollTo(0, 0);
    }

    $(window).bind("pageshow", function(event) {
        if (event.originalEvent.persisted) {
            document.querySelector('.site-wrapper-dark').style.cssText = 'opacity: 1';
        }
    });

    document.querySelector('.site-wrapper-dark').style.cssText = 'opacity: 1';


    // scroll to filter after clicking button inside homepage
    const c = Cookies.get('scroll-filter');
    if(c != undefined) {
        Cookies.remove('scroll-filter');
        setTimeout(() => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".aparts-filter-main").offset().top - 80
            }, 2000);
        }, 100)
    }

    // hide refresh filter 
    if($( window ).width() <= 767) {
        let $mob = $('#refresh-filter-mob');
        if($('.filter-no-results').length != 0) {
            $mob.css({display: 'none'});
        } else {
            $mob.css({display: 'block'});
        }
    }

    const el = document.querySelector('.house-tooltip.k');
    if(el != undefined) el.addEventListener('click', function() {
        $('.js-refresh-filter').click();
       setTimeout(() => {
        $('label[for="filter-1"]').click();
       }, 600);
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".aparts-filter-main").offset().top - 80
        }, 2000);
    });



    document.querySelectorAll('.call-js').forEach(el => el.addEventListener('click', function(e){
        //e.preventDefault();
        ignore_onbeforeunload = true;
        e.stopPropagation();
        console.log("gtag-1");
        if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas', 'event_label': 'skambutis',});
        if(typeof gtag === "function") gtag('event', 'conversion', {'send_to': 'AW-10780676696/-3uLCOTSmokYENik0JQo','event_callback': () => {}});
      
    }));

    document.querySelectorAll('.mail-js').forEach(el => el.addEventListener('click', function(e){
        //e.preventDefault();
        ignore_onbeforeunload = true;
        e.stopPropagation();
        console.log("gtag-2");
        if(typeof gtag === "function") gtag('event','paspaudimas', {'event_category': 'mygtukas', 'event_label': 'email',});
        if(typeof gtag === "function") gtag('event', 'conversion', {'send_to': 'AW-10780676696/LZEBCOfSmokYENik0JQo','event_callback': () => {}});
      
    }));



});

setTimeout(() => {
    const el = document.querySelector('.about-section-3');
    if(el == undefined)return;
    const url = new URL(window.location.href);
    if(window.location.hash != '#sss' && !url.searchParams.has('sss')) return;
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".about-section-3").offset().top
    }, 1000);
},300);



//floor-svg-visible
// const observer = new IntersectionObserver((entries) => {
//     entries.forEach((entry) => {
//         if(entry.isIntersecting) {
//             if(typeof gtag === "function") gtag('event', 'conversion', {
//                 'send_to': 'AW-10780676696/oT4yCOrSmokYENik0JQo',
//                 'event_callback': () => {}
//             });
          
//             observer.unobserve(entry.target);
//             observer.disconnect();
//         }
//     })
//   },{threshold: 0.8});

//   observer.observe(document.querySelector('.footer-content'));